import * as React from 'react';

import useRequest from '../../common/services/request';

import compareConstants    from './compare.constants';
import CompareContext      from './compare.context';
import compareReducer      from './compare.reducer';
import compareInitialState from './compare.state';

function CompareProvider(props) {
  const { children } = props;

  const request = useRequest();

  const [state, dispatch] = React.useReducer(compareReducer, compareInitialState);

  const setCompareTradeOffers = React.useCallback((tradeOffers) => {
    dispatch({
      tradeOffers,
      type: compareConstants.SET_COMPARE_TRADE_OFFER,
    });
  }, [dispatch]);
  const getCompareList        = React.useCallback((tradeOffers) => {
    dispatch({ type: compareConstants.GET_COMPARE_LIST_REQUEST });

    return request.post('/api/compare', { offers: tradeOffers })
      .then((response) => {
        return dispatch({
          type: compareConstants.GET_COMPARE_LIST_SUCCESS,
          ...response,
        });
      })
      .catch((error) => {
        return dispatch({
          type: compareConstants.GET_COMPARE_LIST_FAILURE,
          ...error,
        });
      });
  }, [dispatch]);

  const context = React.useMemo(() => {
    return {
      ...state,
      getCompareList,
      setCompareTradeOffers,
    };
  }, [getCompareList, state]);

  return (
    <CompareContext.Provider value={context}>
      {children}
    </CompareContext.Provider>
  );
}

export default CompareProvider;